<template>
  <span>
    <!-- 名前表示順 -->
    <template>
      <span class="secondTitle">{{ fullName(name,middleName,surname,nameOrder) }}</span>
    </template>
  </span>
</template>

<script>

export default {
  name: "NameOrder",

  /*
      name:         名
      middleName:   ミドルネーム
      surname:      姓
      nameOrder:    名表示順
    */
  props: ["name", "middleName", "surname", "nameOrder"]
};
</script>

<style scoped>
</style>
